import 'react-app-polyfill/ie9'

import React from 'react';
import './App.css';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Layout from './hoc/layout/Layout'
import ZahtjevInputLayout from './hoc/layout/ZahtjevInputLayout';
import ZahtjevStatusLayout from './hoc/layout/ZahtjevStatusLayout';

function App() {

  return (
    <BrowserRouter>
      <Layout>
        <Switch>
          <Route path="/status" component={ZahtjevStatusLayout} naslov="Naslov" />
          <Route path="/" component={ZahtjevInputLayout} />
        </Switch>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
